var OCS = OCS || {};
OCS.Data = OCS.Data || {};
OCS.Data.Geometry = OCS.Data.Geometry || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.Classes = OCS.Geometry.Classes || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Functions.define_GeometryManager_class = function (in_implements) {
    var implements = [Options, Events];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        class_type: "Manager",
        class_name: "GeometryManager",
        options: {
            default_method: 'geometries',
            geometry_fetched_event: "fetched",
            time_to_request: 400,
            max_ids_to_request: 100,
            request_method: "GET"
        },
        geoserver_methods: ["geometries"],
        bound_methods: {},
        stored_request: [],
        fetch_geom_timer: null,
        initialize: function (op) {
            this.setOptions(op);
            this.get_geoserver_methods();
            this.bound_methods.on_geom_req_success = this.on_geom_req_success.bind(this);

        },


        /*
         *
         *
         * Action Methods
         *
         */

        /**
         * Fetch geometries based on the input options, if we have a timer greater than 0, store it for collection
         * @param options
         */

        fetch_geometries: function(options) {
            if(!options || (!options.id && (!options.table || !options.table_id))) {
                return false;
            }

            var geom;
            if(options.table && options.table_id) {
                geom = OCS.Geometry.Functions.getGeometry(options.table, options.table_id, options.projection, options.simplify);
                if(geom) {
                    return geom;
                }
            }
            if(options.id) {
                geom = OCS.Geometry.Functions.getGeometryBySid(options.id, options.projection, options.simplify);
                if(geom) {
                    return geom;
                }
            }

            // So we don't have it

            // set the request in motion, lets figure out the time between request and how long to wait on this particular request
            var time_to_request = this.options.time_to_request;
            if(options.time_to_request) {
                time_to_request = options.time_to_request;
            }

            if(time_to_request >= 0) {
                this.stored_request.push(options);
                if(!this.fetch_geom_timer) {
                    this.fetch_geom_timer = setTimeout(this.on_fetch_geometry.bind(this), time_to_request);
                }
            } else {
                return this.on_fetch_geometry(options);
            }
            return false;

        },
        fetch_locate: function(options) {
            var req_data = this.get_std_request_options(options);
            req_data.x = options.x;
            req_data.y = options.y;
            if(options.table) {
                req_data.table = options.table;
            }
            if(options.geometry) {
                req_data.geometry = 1;
            }
            if(options.dist_units) {
                req_data.dist_units = options.dist_units;
            }
            if(options.dist_limit) {
                req_data.dist_limit = options.dist_limit;
            }
            return OCS.Geometry.Functions.MakeLocateRequest(req_data, this.bound_methods.on_geom_req_success, null, this.options.request_method);
        },
        fetch_table: function(options) {
            var url = OCS.Geometry.Functions.getURL(options.method);
            delete options.method;
            return OCS.Geometry.Functions.MakeTableRequest(options, this.bound_methods.on_geom_req_success, url, this.options.request_method);
        },
        geometry_fetched: function (data) {
            this.fireEvent(this.options.geometry_fetched_event, data);
            return this;
        },
        request: function(options) {
            if(!options) {
                console.error("ocsgeometrymanager: Must pass request options");
                return false;
            }
            if(!options.method) {
                options.method = this.options.default_method;
            } else {
                if(!this.geoserver_methods.contains(options.method)) {
                    return false;
                }
            }
            var promises = [];
            switch(options.method) {
                case "geometries":
                    promises = this.request_geometries(options);
                    break;
                case "locate":
                    promises = this.request_locate(options);
                    break;
                default:
                    promises = this.request_table(options);
                    break;
            }

            return new OCS.Geometry.Classes.GeometryRequestGroupThenable(promises);
        },
        request_geometries: function(options) {
            var promises = [];
            if(options.id) {
                promises.push(new OCS.Geometry.Classes.RequestPromise(options, this, this.fetch_geometries.bind(this)));
            }
            if(options.ids && options.ids.length) {
                var req_ops = this.get_std_request_options(options);
                options.ids.each(function(id) {
                    req_ops.id = id;
                    promises.push(new OCS.Geometry.Classes.RequestPromise(req_ops, this, this.fetch_geometries.bind(this)));
                }.bind(this));
            }
            return promises;
        },
        request_locate: function(options) {
            var promises = [];
            if(options.x && options.y) {
                promises.push(new OCS.Geometry.Classes.RequestPromise(options, this, this.fetch_locate.bind(this)));
            }
            return promises;
        },
        request_table: function(options) {
            var promises = [];
            if(options.method) {
                promises.push(new OCS.Geometry.Classes.RequestPromise(options, this, this.fetch_table.bind(this)));
            }
            return promises;
        },
        on_fetch_geometry: function(base_request) {
            if(this.fetch_geom_timer) {
                clearTimeout(this.fetch_geom_timer);
            }
            this.fetch_geom_timer = null;
            var i = 0;
            var req_data = {};
            if(this.stored_request && this.stored_request.length) {
                base_request = this.stored_request.shift();
            }

            // Need a base request beyond this point.
            if(!base_request) {
                return false;
            }
            if(base_request.projection) {
                req_data.projection = base_request.projection;
            }
            var url = OCS.Geometry.Functions.getURL('geometries');
            if(base_request.url) {
                url = base_request.url;
            }
            var timer = this.options.time_to_request;
            if(base_request.time_to_request) {
                timer = base_request.time_to_request;
            }
            if(timer < 0) {
                timer = 0;
            }
            if(!url) {
                this.stored_request.push(base_request);

                this.fetch_geom_timer = setTimeout(this.on_fetch_geometry.bind(this), timer);
                return false;
            }


            if(base_request.simplify) {
                req_data.simplify = base_request.simplify;
            } else {
                req_data.simplify = 0;
            }
            var ids = [base_request.id];
            var len = this.stored_request.length;
            var request;

            var max_ids = this.options.max_ids_to_request;
            if(base_request.max_ids_to_request) {
                max_ids = base_request.max_ids_to_request;
            }

            for(i; i<len; i++) {
                request = this.stored_request.shift();
                if(ids.length < max_ids) {
                    if(req_data.projection === request.projection && (req_data.simplify === request.simplify || (!req_data.simplify && !req_data.simplify)) && (base_request.url === request.url || url === request.url)) {
                        if(!request.max_ids_to_request || (ids.length < request.max_ids_to_request && request.max_ids_to_request >= max_ids)) {
                            ids.push(request.id);
                        } else {
                            // This request demands fewer items be placed along side it.
                            this.stored_request.push(request);
                        }
                    } else {
                        this.stored_request.push(request);
                    }
                }else {
                    // Break out of the loop
                    this.stored_request.push(request);
                    i=len+1;
                }

            }
            req_data.ids = ids;
            var req = OCS.Geometry.Functions.MakeGeometriesRequest(req_data, this.bound_methods.on_geom_req_success, url, this.options.request_method);
            if(req) {
                if(timer >= 0 && this.stored_request.length) {
                    this.fetch_geom_timer = setTimeout(this.on_fetch_geometry.bind(this), timer);
                }
                return req;
            }

        },

        on_geom_req_success: function(response) {
            if(response.json && response.json.features && response.json.features.length) {
                response.json.features.each(function(feature) {
                    if(!feature.properties) {
                        feature.properties = {};
                    }
                    if(response.json.crs) {
                        feature.crs = response.json.crs;
                    }
                    this.geometry_fetched(new OCS.Geometry.Classes.GeoJsonFeatureData(feature));
                }, this);
            }
            if(response.json && response.json.message && !response.json.features && response.request.req_ids) {
                response.request.req_ids.each(function(id) {
                    this.geometry_fetched(new OCS.Geometry.Classes.GeoJsonFeatureData({id: id}));
                }, this);
            }
        },

        get_geoserver_methods: function() {
            var url = OCS.Geometry.Functions.getURL();
            if(url) {
                OCS.Functions.get_ajax_manager().request('geoserver_methods', {
                    'method': this.options.request_method, 'url': url, 'dataType': 'json', 'responseType': 'json', cache: true,
                    'onSuccess': function(resp) {
                        if(resp.json && resp.json.methods) {
                            this.geoserver_methods = resp.json.methods;
                        }
                    }.bind(this)
                }).send();
            }

        },

        get_std_request_options: function(options) {
            var req_data = {};
            if (options.projection) {
                req_data.projection = options.projection;
            }
            if (options.query_projection) {
                req_data.query_projection = options.query_projection;
            }
            if(options.simplify) {
                req_data.simplify = options.simplify;
            }
            return req_data;

        },
        /*
         * 
         * Destroy Method
         * 
         */
        destroy: function () {
            if(this.fetch_geom_timer) {
                clearTimeout(this.fetch_geom_timer);
            }
            this.stored_request = [];
            this.fetch_geom_timer = null;
            this.fireEvent('geometry_manager_destroyed', this);
            this.removeEvents();

        }
    });
};
OCS.Geometry.Classes.GeometryManager = OCS.Geometry.Functions.define_GeometryManager_class();
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "init": OCS.Geometry.Functions.define_GeometryManager_class,
            "Geometry": OCS.Data.Geometry
        };
    }
} catch (e) {

}